import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductCard, ProductTile, theme } from '@notino/react-styleguide';

import { useFormatPrice } from '@components/PriceLabel/useFormattedPrice';
import { messages } from '@components/Universals/ProductItem/messages';
import { IVoucherDiscount } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/VoucherDiscount/VoucherDiscount';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { styled } from '@linaria/react';

type Props = {
  voucherDiscount: IVoucherDiscount;
};

const VoucherCode = styled.strong`
  color: ${theme.color.text.primary};
  font-weight: 700 !important;
`;

export const ProductTileDiscount = ({ voucherDiscount }: Props) => {
  const formatPrice = useFormatPrice();
  const { release_discovery_product_card_2026 } = useFeatureFlags();

  function getVoucherDiscountDecoration() {
    if (voucherDiscount?.tags?.includes('summerblackfriday')) {
      return 'summerBlackFriday';
    }
    if (voucherDiscount?.tags?.includes('blackfriday')) {
      return 'blackFriday';
    }
  }

  const DiscountComponent = release_discovery_product_card_2026
    ? ProductCard.Discount
    : ProductTile.Discount;

  if (!DiscountComponent) {
    return null;
  }

  return (
    <DiscountComponent
      decoration={getVoucherDiscountDecoration()}
      discountAmount={
        formatPrice({
          value: voucherDiscount.discountedPrice,
        })!.formattedPriceWithCurrency
      }
      discountDescription={
        <FormattedMessage
          {...messages.voucherDescriptionText}
          values={{
            code: <VoucherCode>{voucherDiscount.code}</VoucherCode>,
          }}
        />
      }
    />
  );
};
